/**
 * Created by chenqifeng on 2016/8/31.
 */

import $ from 'jquery';
import maple from 'maple';

import {request} from '../http';
import domain from '../domain';

import mallList from '../../../../setting/mallShop.json';
import marketList from '../../../../setting/marketShop.json';

var BaseService = function(){
    if(domain.env === 'online'){
        this.domain = "//base.51tiangou.com";
    }else{
        this.domain = "//base." + domain.env + ".66buy.com.cn";
    }
};

/**
 * 城市列表
 * @param params
 */
BaseService.prototype.cityList = function (params) {
    var that = this;
    params.type = 'GET';
    that._serviceAjaxCom("/publics/city/list", params);
};
BaseService.prototype.getAccount = function (params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/tgou/easemob/getAccount", params);
};
BaseService.prototype.isHaveHomepage = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/store/isHaveHomepage", params);
};

BaseService.prototype.getMemberAddress = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/store/getMemberAddress", params);
};

BaseService.prototype.storeCreditCard = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/storeCreditCard/queryByCateIds", params);
};

BaseService.prototype.storeLocation = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/notice/query/storeLocation", params);
};

BaseService.prototype.cityLocate = function (params) {
    var that = this;
    params.type = 'GET';
    that._serviceAjaxCom("/publics/city/locate", params);
};
BaseService.prototype.hotCity = function (params) {
    var that = this;
    params.type = 'GET';
    that._serviceAjaxCom("/publics/city/hot/list", params);
};
//通过STOREID查询省份简称
BaseService.prototype.queryProByStoreId = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/storeAddress/queryProByStoreId", params);
};

/**
 * 自提点查询
 * @param params
 */
BaseService.prototype.queryPickUpSiteByStoreId = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/pickupsite/queryPickUpSiteByStoreId", params);
}

BaseService.prototype.storeInfo = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/store/info", params);
};

BaseService.prototype.judgeStoreByCity = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/store/judgeStoreByCity", params);
};

BaseService.prototype._serviceAjaxCom = function(url,params){
    params.url = this.domain + url;
    return request(params);
};

/**
 * 通过gps取门店
 * */
BaseService.prototype._getGpsShop = function(lat, lon, source=1){
	let that = this
        , params
        ;

	if( lat && lon ){
	    params = {
		    latitude: lat,
		    longitude: lon,
		    type: source
        }
    }
    else if( typeof lat === 'object' ){
	    params = lat
    }
    else{
        lat = maple.cookie('lat');
        lon = maple.cookie('lon');

		params = {
			latitude: lat,
			longitude: lon,
			type: source
		}
    }

    params.type = 'POST';
    return that._serviceAjaxCom("/publics/store/nearby/store", params);
};
/**
 * 计算弧度
 * */
BaseService.prototype.rad = function(d){
	return d * Math.PI / 180.0;
};
/**
 * 根据经纬度，获取距离
 */
BaseService.prototype._getDistance = function(lat1, lng1, lat2, lng2){
	//地球半径
	var EARTH_RADIUS = 6378.137;
	if (lat1 == '' || lng1 == '' || lat2 == '' || lng2 == '')
		return 0;
	var radLat1 = this.rad(lat1);
	var radLat2 = this.rad(lat2);
	var a = radLat1 - radLat2;
	var b = this.rad(lng1) - this.rad(lng2);
	var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a/2),2) +
			Math.cos(radLat1)*Math.cos(radLat2)*Math.pow(Math.sin(b/2),2)));
	s = s * EARTH_RADIUS;
	s = Math.round(s * 10000) / 10000;
	return s;
};

/**
 * 获取去过的门店
 * @param   {Number}    cityId
 * @param   {Number}    source  门店类型：1.百货；2.超市
 * @return  {Promise}   在 resolve 时出入 storeId
 * @desc    从 cookie 中获取 cityId、经纬度（lat lon）、去过的门店列表（usualShop）
 *      从去过的门店中获取当前城市最近去过的的门店
 *      若没有则根据 GPS 发送请求获取当前距离最近的门店
 *      若没有则根据 mallShop.json 和 market.json 获取当前城市的默认门店
 * */
BaseService.prototype.getUsualShop = function(cityId, source){
    var that = this
        , cityId = maple.cookie('cityId')
        , lat = maple.cookie('lat')
        , lon = maple.cookie('lon')
        , storeList = JSON.parse(maple.cookie('usualShop') || '[]')
        , storeId
        , defer = $.Deferred()
        , rs
        ;

    if( source ){
	    storeList = storeList.filter(d=>d.source == source);
    }
    if( storeList.length ){
        storeId = storeList[0].id;
    }

    if( storeId ){
        defer.resolve( storeId );
    }
    else if( lat && lon ){
        that._getGpsShop().then(function(response){
            var data
                , tempCityId
                , distance
                , storeId
                ;

            if( response.success ){
                data = response.data;

	            if (data && data.id) {
		            tempCityId = data.storeAddress.fkCityId;
		            distance = that._getDistance(lat, lon, data.storeAddress.dimension, data.storeAddress.longitude);
	            }
	            //小余5公里
	            if (data && distance <= 5 && tempCityId == cityId) {
		            storeId = data.id;
	            } else {
		            if( source === 1 ){
			            storeList = mallList.filter(d=>d.cityId == cityId);
		            }
		            else{
			            storeList = marketList.filter(d=>d.cityId == cityId);
		            }

		            if( storeList.length ){
			            storeId = storeList[0].id;
		            }
	            }
            }
            else{
                if(response && response.message && response.message !== 'undefined') {
                    maple.notice(response.message)
                }else {
                    maple.notice('网络好像不给力喔，请检查一下您的网络设置')
                }
            }

	        defer.resolve( storeId );
        });
    }
    else{
        if( source === 1 ){
            storeList = mallList.filter(d=>d.cityId == cityId);
        }
        else{
            storeList = marketList.filter(d=>d.cityId == cityId);
        }

        if( storeList.length ){
            storeId = storeList[0].id;
        }

        defer.resolve( storeId );
    }

    return defer.promise();
};

/**
 * 查热门城市及城市下所有百货超市
 * */
BaseService.prototype.allCityStore = function(params){
	this._serviceAjaxCom('/publics/city/hot/store', params);
};
BaseService.prototype.queryStoreInfoById = function(params){
    this._serviceAjaxCom('/publics/store/queryStoreInfoById', params);
};

BaseService.prototype.brandQueryAll = function(params){
	this._serviceAjaxCom('/publics/brand/queryAll', params);
};

/**
 * 判断超市是否支持扫码购
 * */
BaseService.prototype.queryOnlineShopping = function(params){
    this._serviceAjaxCom('/publics/store/queryOnlineShopping', params);
};

/**
 * 以城市维度查支持扫码购超市
 * */
BaseService.prototype.queryShoppingBycity = function(params){
    this._serviceAjaxCom('/publics/store/city/shopping', params);
};

/**
 * 查询超市扫码购相关信息
 * */
BaseService.prototype.queryMarketShopping = function(params){
    this._serviceAjaxCom('/publics/store/queryMarketShopping', params);
};

/**
 * 查门店以及扫码购信息
 * */
BaseService.prototype.storeAndMarketShopping = function(params){
    this._serviceAjaxCom('/publics/store/storeAndMarketShopping', params);
};

/**
 * 查有门店的热门城市列表
 * */
BaseService.prototype.haveStoreCity = function(params){
	return this._serviceAjaxCom('/publics/city/hot/haveStore', params);
};

/**
 * 查该城市下精选超市
 * */
BaseService.prototype.pickedMarket = function(params){
	return this._serviceAjaxCom('/publics/store/queryPickedMarket', params);
};

/**
 * 城市列表中查城市下的超市信息
 * */
BaseService.prototype.marketByCity = function(params){
	return this._serviceAjaxCom('/publics/store/market/cityId', params);
};

/**
 * 营业执照按店铺查询
 * */
BaseService.prototype.queryLicenceByStoreId = function(params){
	return this._serviceAjaxCom('/publics/businessLicenceInfo/queryByStoreId', params);
};

/**
 * 兰蔻模式商品详情页展示门店列表
 * */
BaseService.prototype.queryStoreItem = function(params){
	params.method = 'POST';

	return this._serviceAjaxCom('/publics/store/queryForItemDetail', params);
}

BaseService.prototype.checkDelivery = function (params) {
    params.method = 'POST';
	return this._serviceAjaxCom('/publics/store/check/delivery', params);
};

BaseService.prototype.license = function(params){
	params.method = 'POST';
	return this._serviceAjaxCom('/publics/merchantInfo/api/aboutUs/query', params);
};

/**
 * 查询协议版本时间
 * @param {*} url 
 * @param {*} params 
 */
BaseService.prototype.queryVersionDate = function (params) {
    params.method = 'POST';
    return this._serviceAjaxCom("/publics/merchantInfo/api/versionDate/query", params);        
}

// 确认订单查询跨境门店的协议
BaseService.prototype.getOverseaAgreementByStoreId = function (params) {
    params.method = 'GET';
    return this._serviceAjaxCom("/publics/overseaAgreement/getByStoreId", params);
}

// 查询跨境门店协议的具体内容
BaseService.prototype.getOverseaAgreementById = function (params) {
    params.method = 'GET';
    return this._serviceAjaxCom("/publics/overseaAgreement/getById", params);
}

// 获取饷店售后省份列表
BaseService.prototype.provinceList = function (params) {
    params.type = 'GET';
    this._serviceAjaxCom('/publics/province/list', params);
};

// 获取饷店售后城市列表
BaseService.prototype.cityListByProvince = function (params) {
    params.type = 'GET';
    this._serviceAjaxCom('/publics/city/cities', params);
};

// 获取饷店售后地区列表
BaseService.prototype.districtList = function (params) {
    params.type = 'GET';
    this._serviceAjaxCom('/publics/district/list', params);
};

// 获取客服电话
BaseService.prototype.getKefuTel = function (params) {
    params.type = 'GET';
    this._serviceAjaxCom('/publics/phone/common', params);
};
export default new BaseService();